import React from 'react'
import StaticPage from '../components/StaticPage'

/**
 * Useful links, migrated from the legacy site's Links (jos_weblinks) section.
 */
const LINKS = [
  {
    title: 'BHPA',
    url: 'http://www.bhpa.co.uk',
    description: 'British Hang Gliding and Paragliding Association - the national governing body, ratings, and schools.',
  },
  {
    title: 'SHPF',
    url: 'http://www.shpf.co.uk/',
    description: 'Scottish Hang gliding and Paragliding Federation.',
  },
  {
    title: 'Ettrick & Yarrow',
    url: 'http://www.ettrickandyarrow.co.uk/',
    description: 'The Ettrick and Yarrow valleys - the home of many Wingbeat sites.',
  },
  {
    title: 'The Sick and the Wrong',
    url: 'http://www.sickandwrong.co.uk/',
    description: 'Long-standing paragliding community site.',
  },
]

function LinksPage() {
  return (
    <StaticPage title="Links" intro="Useful paragliding links">
      <ul className="links-list">
        {LINKS.map((l) => (
          <li key={l.url}>
            <a href={l.url} target="_blank" rel="noopener noreferrer">{l.title}</a>
            {l.description && <span className="link-desc"> - {l.description}</span>}
          </li>
        ))}
      </ul>
      <p className="muted">
        Know a link that should be here? <a href="/contact">Let us know.</a>
      </p>
    </StaticPage>
  )
}

export default LinksPage
